import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ClientDetails.css';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';

function ClientDetails({ clientModal, setClientModal, client }) {
    const [ageString, setAgeString] = useState('');
    const [phoneString, setPhoneString] = useState('');
    const [referralPhoneString, setReferralPhoneString] = useState('');
    const handleCloseModal = () => {
        setClientModal(false);
    }

    function addDashes(phone) {
        return "(" + phone.slice(0, 3) + ") " + phone.slice(3, 6) + "-" + phone.slice(6);
    }

    function determinPhoneType(client) {
        switch (client.phone_type) {
            case 0:
                return "Cell: " + addDashes(client.phone);
            case 1:
                return "Work: " + addDashes(client.phone);
            case 2:
                return "Home: " + addDashes(client.phone);
            case 3:
                return "please do not communicate via phone with this client";
            default:
                return "Not provided";
        }
    }

    function displayAges(client) {
        const ages = client.household_members || [];
        let string = `Total in Home: ${client.household_members} - ` + `Ages: ` + `${ages.join(', ')}`;
        setAgeString(string);
    }

    return (
        <>
            <Modal
                size="lg"
                show={clientModal}
                onHide={() => handleCloseModal()}
                backdrop="static"
                id="modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="w-100 text-center">
                        {client.name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container fluid>
                        <Table>
                            <tbody key={client.id}>
                                <tr className="text-center"><td><h5>Phone:</h5></td><td>{client.phone}</td></tr>
                                <tr className="text-center"><td><h5>Email:</h5></td><td>{client.email}</td></tr>
                                <tr className="text-center"><td><h5>Address:</h5></td><td>{client.address}</td></tr>
                                <tr className="text-center"><td><h5>Age:</h5></td><td>{client.dob}</td></tr>
                                {/* <tr className="text-center"><td><h5>Household:</h5></td><td>{client.household_members}</td></tr> */}
                                <tr className="text-center"><td><h5>Referrer:</h5></td><td>{client.staff_name}</td></tr>
                                <tr className="text-center"><td><h5>Referrer Email:</h5></td><td>{client.staff_email}</td></tr>
                                <tr className="text-center"><td><h5>Referral Agency:</h5></td><td>{client.referral_partner}</td></tr>
                                <tr className="text-center"><td><h5>Referral Agency Phone:</h5></td><td>{client.referral_partner_phone}</td></tr>
                            </tbody>
                        </Table>
                    </Container>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <Button
                        onClick={handleCloseModal}>Close</Button></Modal.Footer>
            </Modal>
      </>
    );
}

export default ClientDetails;